module.exports = __webpack_public_path__ + "img/1440.fc26aa84.jpg";